import React, { useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

const UserProfile = ({ user, onLogout, onNavigateToSettings }) => {
	const [showUserDropdown, setShowUserDropdown] = useState(false);
	const toggleUserDropdown = () => setShowUserDropdown(!showUserDropdown);

	return (
		<View style={styles.userContainerWrapper}>
			<TouchableOpacity style={styles.profileContainer} onPress={toggleUserDropdown}>
				<View style={styles.profileAvatar}>
					<Text style={styles.profileInitials}>{user?.signInDetails?.loginId?.charAt(0).toUpperCase()}</Text>
				</View>
				<Ionicons name="chevron-down" size={16} color="#888" />
			</TouchableOpacity>
			{showUserDropdown && (
				<View style={styles.userDropdown}>
					<TouchableOpacity
						style={styles.dropdownItem}
						onPress={() => {
							onNavigateToSettings();
							setShowUserDropdown(false);
						}}>
						<Ionicons name="settings-outline" size={18} color="#888" />
						<Text style={styles.dropdownItemText}>Settings</Text>
					</TouchableOpacity>
					<View style={styles.dropdownDivider} />
					<TouchableOpacity
						style={styles.dropdownItem}
						onPress={() => {
							onLogout();
							setShowUserDropdown(false);
						}}>
						<Ionicons name="log-out-outline" size={18} color="#888" />
						<Text style={styles.dropdownItemText}>Logout</Text>
					</TouchableOpacity>
				</View>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	userContainerWrapper: {
		position: "relative",
		zIndex: 2000, // Ensure dropdown is above other content, increased zIndex
	},
	profileContainer: {
		flexDirection: "row",
		alignItems: "center",
		gap: 10,
		// cursor: "pointer", // Not a standard RN style property
	},
	profileAvatar: {
		backgroundColor: "#4d2",
		width: 30,
		height: 30,
		borderRadius: 15,
		justifyContent: "center",
		alignItems: "center",
	},
	profileInitials: {
		color: "#fff",
		fontSize: 13,
		fontWeight: "600",
	},
	userDropdown: {
		position: "absolute",
		top: 48,
		right: 0,
		width: 180,
		backgroundColor: "#2A2A2A",
		borderRadius: 10,
		padding: 6,
		// zIndex: 200, // zIndex is on the wrapper
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.3,
		shadowRadius: 8,
		elevation: 5, // for Android shadow
		borderWidth: 1,
		borderColor: "#3A3A3A",
	},
	dropdownItem: {
		flexDirection: "row",
		alignItems: "center",
		gap: 12,
		padding: 10,
		borderRadius: 6,
	},
	dropdownItemText: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
	},
	dropdownDivider: {
		height: 1,
		backgroundColor: "#3A3A3A",
		marginVertical: 4,
	},
});

export default UserProfile;
